import { useCallback, useEffect } from 'react';

// Single audio instance
let globalAudio: HTMLAudioElement | null = null;

export const useSound = (path: string) => {
  useEffect(() => {
    if (!globalAudio) {
      globalAudio = new Audio();
    }

    const unlockAudio = () => {
      if (!globalAudio) return;
      // preload
      if (!globalAudio.src || !globalAudio.src.endsWith(path)) {
        globalAudio.src = path;
      }

      const originalVolume = globalAudio.volume;
      globalAudio.volume = 0;

      globalAudio
        .play()
        .then(() => {
          if (!globalAudio) return;
          globalAudio.pause();
          globalAudio.currentTime = 0;
          globalAudio.volume = originalVolume;
        })
        .catch(() => {
          if (!globalAudio) return;
          globalAudio.volume = originalVolume;
        });

      ['click', 'touchstart', 'keydown'].forEach((event) => {
        document.removeEventListener(event, unlockAudio);
      });
    };

    ['click', 'touchstart', 'keydown'].forEach((event) => {
      document.addEventListener(event, unlockAudio);
    });

    return () => {
      ['click', 'touchstart', 'keydown'].forEach((event) => {
        document.removeEventListener(event, unlockAudio);
      });
    };
  }, []);

  const playSound = useCallback((volume = 0.5) => {
    if (!globalAudio) return;
    if (!globalAudio.src || !globalAudio.src.endsWith(path)) {
      globalAudio.src = path;
    }
    globalAudio.volume = volume;
    globalAudio.currentTime = 0;
    globalAudio.play();
  }, []);

  return { playSound };
};
